import { sleep } from './../../utils/sleep';
import { Freeer } from '.';

/*
 * @Author: Yu JiaZe
 * @Description:
 * @Date: 2020-01-03 15:08:12
 * @LastEditTime: 2020-04-24 18:59:36
 */

const win: Window = window;

const originSetTimeout = win.setTimeout;
const originSetInterval = win.setInterval;

export const createTimerSandbox: Freeer = () => {
    const timeoutIds: number[] = [];
    const intervalIds: number[] = [];

    win.setTimeout = (...args) => {
        const id = originSetTimeout.apply(win, args);
        timeoutIds.push(id);
        return id;
    };

    win.setInterval = (...args) => {
        const id = originSetInterval.apply(win, args);
        intervalIds.push(id);
        return id;
    };

    return {
        free() {
            win.setTimeout = originSetTimeout;
            win.setInterval = originSetInterval;
            timeoutIds.forEach(async (id) => {
                // 从 乾坤 抄来的
                // 延迟 timeout 的清理，因为可能会有动画还没完成
                await sleep(500);
                window.clearTimeout(id);
            });
            intervalIds.forEach((id) => {
                window.clearInterval(id);
            });

            return () => {};
        },
    };
};
